import { Link } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import { Col, Row } from "reactstrap";
import { H5, LI, UL } from "../../../../../AbstractElements";
import { ShareIt } from "../../../../../Constants/Constants";
import { ProductSocialLinks } from "../../../../../Data/Applications/ECommerce/ECommerce";

export const ProductSocial = () => {
  return (
    <Fragment>
      <Row className="py-1">
        <Col md="4">
          <H5 className="product-title">{ShareIt}</H5>
        </Col>
        <Col md="8">
          <div className="product-icon">
            <UL className="product-social simple-list flex-row">
              {ProductSocialLinks.map((item, index) => (
                <LI className="d-inline-block" key={index}>
                  <Link to={item.link} target="_blank">
                    <i className={item.text}></i>
                  </Link>
                </LI>
              ))}
            </UL>
          </div>
        </Col>
      </Row>
      <hr />
    </Fragment>
  );
};